import React, { Fragment, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';

const Logout = () => {
    const { oktaAuth } = useOktaAuth();
    useEffect(() => {
        oktaAuth.tokenManager.clear();
        window.opener = null;
        window.open("", "_self");
        window.close();
    }, []);

    return(
        <>
            <h1>Logged Out</h1>
        </>
    );
};

export default Logout;